import React, { useContext } from "react";
import { Link } from "gatsby";
import useOnclickOutside from "react-cool-onclickoutside";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import handleContactClick from "../../utils/handleContact";
import { ContactFormContext } from "../../context/contactFormContext";

import RightArrowDisabledIcon from "../../assets/images/rightArrowDisabled.svg";
import RightArrowIcon from "../../assets/images/rightArrow.svg";

export default function MobileNavigation({
  open,
  setOpen,
  isBrowser,
  navigation,
  classNames,
}) {
  const { handleOpenContact } = useContext(ContactFormContext);
  const ref = useOnclickOutside(() => {
    setOpen(false);
  });

  return (
    <div ref={ref}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none ring-0 focus:ring-0"
      >
        <span className="sr-only">Open main menu</span>
        {open ? (
          <p className="block h-6 w-6" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </p>
        ) : (
          <p className="block h-6 w-6" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </p>
        )}
      </button>

      {open && (
        <div className="flex sm:hidden justify-center w-full mx-auto bg-[white]">
          <div className="absolute inset-y-14 -right-6 pt-8 flex flex-col w-screen h-max bg-[white] space-y-4 pb-10">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={(e) => {
                  handleContactClick(e, item.name, handleOpenContact);
                  setOpen(false);
                }}
                className={classNames(
                  isBrowser() && window.location.pathname.includes(item.href)
                    ? "text-cstm-green"
                    : "text-[black] hover:text-[gray]  focus:outline-none",
                  "px-3 pt-2 pb-1 rounded-md text-sm w-11/12 no-click-highlight "
                )}
                style={{ marginLeft: "2vw" }}
                aria-current={
                  isBrowser() && window.location.pathname.includes(item.href)
                    ? "page"
                    : undefined
                }
              >
                {item.menu ? (
                  <Menu as="div" className="relative">
                    <div>
                      <Menu.Button className="w-full flex justify-between">
                        <span className="sr-only">Open {item.name} menu</span>
                        {item.name}
                        <svg
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          className=" -rotate-90 transform inline w-4 h-4 ml-1 mt-0.5 "
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="z-10 origin-top-right py-4 flex flex-col justify-center absolute top-4 -left-4 mt-2 w-[300px] rounded-md shadow-lg bg-[white] text-[black] focus:outline-none">
                        {item.menuItems.map((menuItem) => (
                          <Menu.Item key={menuItem.img} className="">
                            {({ active }) => (
                              <Link
                                to={menuItem.href}
                                target={menuItem.target || ""}
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700 focus:outline-none"
                                )}
                              >
                                <div className="flex pl-6 md:pl-8 py-4 w-full">
                                  {menuItem.img && (
                                    <img
                                      className="w-12 h-10 pr-3 self-center"
                                      alt={menuItem.name}
                                      src={menuItem.img}
                                    />
                                  )}
                                  <p className="flex flex-col w-full pr-8 group">
                                    <div
                                      className={`${
                                        menuItem.disabled
                                          ? "text-cstm-grey cursor-default"
                                          : menuItem.img
                                          ? "font-medium"
                                          : "group-hover:text-cstm-green"
                                      } flex flex-row  justify-between text-sm md:text-sm-15 items-center`}
                                    >
                                      {menuItem.name}
                                      {!menuItem.img ? (
                                        menuItem.disabled ? (
                                          <img
                                            className={`ml-3`}
                                            src={RightArrowDisabledIcon}
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            className={`ml-3 transition-all group-hover:ml-7`}
                                            src={RightArrowIcon}
                                            alt=""
                                          />
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <span className="text-cstm-grey text-xs">
                                      {menuItem.desc}
                                    </span>
                                  </p>
                                </div>
                              </Link>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                ) : (
                  item.name
                )}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
